import React, { useContext } from "react";
import { userDetailsContext } from "../Context";
import { Link } from "react-router-dom";
import { FaStar } from "react-icons/fa";

const Home = () => {
	const { item } = useContext(userDetailsContext);
	console.log(item);
	return (
		<section className='grid lg:grid-cols-2 gap-5 m-5 sm:m-10 '>
			{item.map((phone, index) => {
				const { id, image, name, price, rate, about } = phone;
				const { star, rating, review } = rate;
				return (
					<Link to={`/info${id}`} key={id} className=' sm:h-72 border shadow-lg '>
						<div className=' bg-white flex flex-col sm:flex-row justify-center sm:justify-between items-start p-1 sm:p-5 rounded-lg space-y-4 '>
							<div className='w-full sm:w-auto flex justify-center sm:justify-start'>
								<img src={image} alt={name} className=' bg-cover  ' width='101' height='200' />
							</div>
							<div className='flex-1 mx-10 flex flex-col justify-center items-center sm:justify-start sm:items-start '>
								<h1 className=' uppercase text-lg font-semibold '>{name}</h1>
								<p>
									<span className=' bg-custom-green p-1 text-white rounded'>
										<FaStar className='inline-block mb-1 mr-1' />
										{star}
									</span>
									<span className='text-small text-gray-400 ml-3'>{rating} Ratings </span>
									<span className='text-small text-gray-400 '>& {review} Reviews</span>
								</p>
								<ul className='list-disc  sm:my-5'>
									{about.map((list, index) => {
										return <li key={index}>{list}</li>;
									})}
								</ul>
							</div>
							<div className=' self-center sm:self-start'>
								<h2 className='mb-3 hover:text-black text-2xl'>&#8377;{price}</h2>
								<button className='sm:hidden bg-blue-500 text-white py-2 px-4 rounded my-2 '>More info</button>
							</div>
						</div>
					</Link>
				);
			})}
		</section>
	);
};

export default Home;
